<template>
  <section class="bg-mobile-bg w-[1240px] mx-auto py-16 pl-16 h-[280px] box-border flex mb-16 relative truncate">
    <div class="flex flex-col justify-center items-start w-[500px] text-white">
        <h2 class="font-semibold mb-8 text-3xl">Download the mobile application for bonus <br>coupons and travel codes</h2>
        <button class="btn">Download mobile app</button>
    </div>
    <img src="../../assets/mob.png" alt="smart phone" class="w-[720px] h-[516px] absolute -rotate-12 right-0 -inset-y-24	">
  </section>
</template>

<script>
export default {

}
</script>